import { Component, OnInit } from '@angular/core';
import { AccountMixin } from 'src/app/services/mixins/account.mixin';
import { PageService } from 'src/app/services/page.service';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { InfoService } from 'src/app/services/info.service';
import { Observable } from 'rxjs';

import { Select } from '@ngxs/store';
import { UserState } from 'src/app/store/states/user.state';


import { BaseComponent } from '../../base.component';


@Component({
    selector: 'app-payment-cancel',
    templateUrl: './payment-cancel.component.html',

})
export class PaymentCancelComponent extends AccountMixin(BaseComponent)
    implements OnInit {
    @Select(UserState.lastSign)
    public lastSign$: Observable<any | null>;

    @Select(UserState.data) public userData$: Observable<Record<string, any>>;

    public actualTime: any;


    public userData: Record<string, any>;

    public constructor(
        protected page: PageService,

        protected title?: Title,
        protected meta?: Meta,
        protected route?: Router,
        protected info?: InfoService,

    ) {
        super(page, title, meta, route, info);
    }

    public ngOnInit(): void {
        super.ngOnInit();


        this.userData$.subscribe(((val) => {
            this.userData = val;
        }));
    }
}
